import React from "react";
import { MessageCircle } from "lucide-react";
import { waLink } from "@/lib/api";
import { usePageMeta } from "@/lib/seo";

const tours = [
  { name: "Desert Safari", img: "https://images.unsplash.com/photo-1451337516015-6b6e9a44a8a3?w=800&q=80", desc: "Dune bashing, camel rides, BBQ dinner and live entertainment." },
  { name: "Dhow Cruise Dinner", img: "https://images.unsplash.com/photo-1531259683007-016a7b628fc3?w=800&q=80", desc: "Traditional dhow along Dubai Marina or Creek with buffet dinner." },
  { name: "Dubai City Tour", img: "https://images.unsplash.com/photo-1518684079-3c830dcef090?w=800&q=80", desc: "Half-day tour: Old Dubai, Gold Souk, Burj Al Arab and Palm Jumeirah." },
  { name: "Burj Khalifa", img: "https://images.unsplash.com/photo-1582672060674-bc2bd808a8f5?w=800&q=80", desc: "At The Top observation deck — 124th floor sunset experience." },
  { name: "Marina Yacht Experience", img: "https://images.unsplash.com/photo-1605281317010-fe5ffe798166?w=800&q=80", desc: "Private 2-hour yacht charter along Dubai Marina with snacks." },
  { name: "Theme Parks", img: "https://images.unsplash.com/photo-1611509347683-6da7b7b06d2f?w=800&q=80", desc: "IMG Worlds, Motiongate, Aquaventure and Global Village access." },
  { name: "Abu Dhabi City Tour", img: "https://images.unsplash.com/photo-1551041777-ed79d0fa00e0?w=800&q=80", desc: "Sheikh Zayed Mosque, Emirates Palace and Ferrari World." },
  { name: "Airport Transfers", img: "https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=800&q=80", desc: "Premium private vehicles to/from DXB, DWC, AUH and beyond." },
];

export default function Tours() {
  usePageMeta("Tours & Experiences", "Curated tours and experiences — desert safaris, city tours, Victoria Falls adventures and more with Makchester Tours & Travel.");
  return (
    <div className="bg-white">
      <section className="bg-[#0A2E4D] text-white py-20">
        <div className="max-w-7xl mx-auto px-6">
          <span className="mk-gold-line mb-6 block" />
          <p className="text-xs uppercase tracking-[0.25em] text-[#D4A62A] font-bold mb-3">Tours &amp; Excursions</p>
          <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl">Dubai, perfectly experienced.</h1>
          <p className="text-slate-300 mt-5 max-w-2xl">Signature tours, transfers and bucket-list experiences booked in minutes.</p>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {tours.map((t) => (
            <div key={t.name} className="mk-card rounded-md overflow-hidden flex flex-col" data-testid={`tour-${t.name.toLowerCase().replace(/\s+/g, "-")}`}>
              <div className="h-44 overflow-hidden">
                <img src={t.img} alt={t.name} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 hover:scale-110" />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="font-serif-display text-lg text-[#0A2E4D]">{t.name}</h3>
                <p className="text-xs text-[#475569] mt-2 flex-1 leading-relaxed">{t.desc}</p>
                <a href={waLink(`Hello Makchester Tours & Travel, I would like to book ${t.name}.`)} target="_blank" rel="noreferrer"
                   className="mt-4 inline-flex items-center justify-center gap-1.5 text-xs bg-[#25D366] hover:bg-[#1ebe57] text-white py-2.5 rounded-full font-medium transition-colors">
                  <MessageCircle size={12} /> Enquire on WhatsApp
                </a>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
